import { combineReducers } from 'redux';

import user from './user';
import layout from './layout';

export default combineReducers({
  user,
  layout,
});